import { Language } from './types';

const BASE_INVOICE_LABELS = {
  invoiceHeader: 'There is no information to display!',
  invoiceBody: 'Please go back to the payment view and try to log in again.',
  invoiceErrorHeader: 'An error has occurred!',
  invoiceErrorBody:
    'An error occurred while trying to get your receipt information, please try again later.',
  invoiceLoadingHeader: 'Please wait',
  invoiceLoadingBody: 'We are getting your receipt information',
  invoiceSend: 'Received',
  invoiceRequested: 'Requested',
  invoicePayableSend: 'Sent',
  invoicePayableRequested: 'Converted to',
  invoicePayableConverted: 'Converted from',
  invoicePayableRate: 'Exchange Rate',
  invoiceFrom: 'From',
  invoiceTo: 'To',
  invoiceDate: 'Date',
  invoicePayDate: 'Pay date',
  invoiceItems: 'Items',
  invoiceItem: 'Item',
  invoiceQTY: 'QTY',
  invoicePrice: 'Price',
  invoiceSubtotal: 'Subtotal',
  invoiceTotal: 'Total',
  invoicePayment: 'Payment',
  invoicePaymentDue: 'Payment Due',
  invoiceDownloadBtn: 'Download receipt',
  invoiceDownloadCepBtn: 'Download receipt CEP Banxico',
  invoiceAttached: 'Download attached file',
};

type LabelsLanguage = keyof typeof BASE_INVOICE_LABELS;

const ACTIVATE_INVOICE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_INVOICE_LABELS,
  ES: {
    invoiceHeader: '¡No hay información para mostrar!',
    invoiceBody:
      'Por favor regrese a la vista de pagos y vuelva intentar acceder.',
    invoiceErrorHeader: '¡Ah ocurrido un error!',
    invoiceErrorBody:
      'Ocurrio un error al intentar obtener la informacion de su comprobante, por favor intente mas tarde',
    invoiceLoadingHeader: 'Por favor espere.',
    invoiceLoadingBody: 'Estamos obteniendo la información de su comprobante.',
    invoiceSend: 'Recibido',
    invoiceRequested: 'Solicitado',
    invoicePayableSend: 'Enviado',
    invoicePayableRequested: 'Convertido a',
    invoicePayableConverted: 'Convertido de',
    invoicePayableRate: 'Tipo de Cambio',
    invoiceFrom: 'De',
    invoiceTo: 'Para',
    invoiceDate: 'Fecha',
    invoicePayDate: 'Fecha de pago',
    invoiceItems: 'Artículos',
    invoiceItem: 'Artículo',
    invoiceQTY: 'Cantidad',
    invoicePrice: 'Precio',
    invoiceSubtotal: 'Subtotal',
    invoiceTotal: 'Total',
    invoicePayment: 'Pago',
    invoicePaymentDue: 'Fecha de pago',
    invoiceDownloadBtn: 'Descargar comprobante',
    invoiceDownloadCepBtn: 'Descargar comprobante CEP',
    invoiceAttached: 'Descargar archivo adjunto',
  },
};

export default ACTIVATE_INVOICE_LABELS;
